





















































import Vue from "vue";
import Component from "vue-class-component";
import { UserAdmin } from "@/store";
import { IAssignToken } from "@/store/user_admin/models";

const AssignTokenFormProps = Vue.extend({
  props: {
    active: Boolean,
    userId: Number,
  },
});

@Component<AssignTokenForm>({
  watch: {
    active: function(newValue) {
      if (newValue) {
        UserAdmin.dispatch("loadTokenList").then(() => {
          this.selectedToken = this.tokenList[0];
        });
      }
    },
  },
})
export default class AssignTokenForm extends AssignTokenFormProps {
  selectedToken: any = null;
  fillError: boolean = false;
  deleteDialog: boolean = false;

  get dialog() {
    return this.active;
  }
  set dialog(value) {
    this.$emit("closing", value);
  }

  get tokenList() {
    return UserAdmin.getters.tokenList;
  }

  send() {
    if (this.userId && this.selectedToken) {
      let tokenInfo: IAssignToken = {
        user: this.userId,
        token_serial: this.selectedToken,
      };
      UserAdmin.dispatch("assignToken", tokenInfo).then(() => {
        this.dialog = false;
      });
    } else {
      this.fillError = true;
    }
  }
  deleteConfirm() {
    this.deleteDialog = true;
  }
  deleteConfirmed() {
    UserAdmin.dispatch("deleteToken", this.userId).then(() => {
      this.deleteDialog = false;
      this.dialog = false;
    });
  }
}
